export default __webpack_public_path__ + "static/media/heavy-traffic-33.4fe4724f.svg";